import React from 'react';
import PortalShell from '@/components/portal/PortalShell';
import LoginForm from '@/components/portal/LoginForm';

const GisLogin: React.FC = () => {
  return (
    <PortalShell>
      <LoginForm
        title="GIS Workspace Sign In"
        subtitle="Access the GIISDEC GIS Workspace."
        accent="amber"
        role="gis-analyst"
        successPath="/gis/dashboard"
        otherPortal={{ label: 'Investor Portal', to: '/investor-login' }}
      />
    </PortalShell>
  );
};

export default GisLogin;
